import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Grid,
  TablePagination,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import ApiService from "../../services/categoryManagementApi";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../components/customLoader";
import DataTable from "react-data-table-component";
import AppWidgetSummary from "../../sections/@dashboard/app/AppWidgetSummary";

const { DashboardApi } = ApiService;

const stickyHeaderStyles = {
  headRow: {
    style: {
      position: "sticky",
      top: 0,
      backgroundColor: "#00a1dd",
      color: "#fff",
      zIndex: 10,
      fontSize: "16px"
    },
  },
  headCells: {
    style: {
      color: "#fff",
      fontWeight: "bold",
    },
  },
};


const DashboardAppPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dealerData, setDealerData] = useState([]);
  const [customerData, setCustomerData] = useState([]);

  const [dealerPage, setDealerPage] = useState(1);
  const [dealerRowsPerPage, setDealerRowsPerPage] = useState(10);
  const [dealerTotalRows, setDealerTotalRows] = useState(0);

  const [customerPage, setCustomerPage] = useState(1);
  const [customerRowsPerPage, setCustomerRowsPerPage] = useState(10);
  const [customerTotalRows, setCustomerTotalRows] = useState(0);

  const navigate = useNavigate();  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await DashboardApi.getDashboardReports();

        setData(resp?.data?.data); 
        setLoading(false);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchData();
  }, []); 

  useEffect(() => {
    const fetchDealerData = async () => {
      try {
        const resp = await DashboardApi.dealerLastLogin({
          pageNumber: dealerPage,
          pageSize: dealerRowsPerPage,

        });
        setDealerData(resp?.data?.data?.dealers || []);
        setDealerTotalRows(resp?.data?.data?.totalCount || 0);
      } catch (error) {
        console.error("Error fetching dealer login data:", error);
      }
    };
    fetchDealerData();
  }, [dealerPage, dealerRowsPerPage]);
  
  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const resp = await DashboardApi.customerLastLogin({
          pageNumber: customerPage,
          pageSize: customerRowsPerPage,
        });
        
        setCustomerData(resp?.data?.data?.users || []);
        setCustomerTotalRows(resp?.data?.data?.totalCount || 0);
      } catch (error) {
        console.error("Error fetching customer login data:", error);
      }
    };
    fetchCustomerData();
  }, [customerPage, customerRowsPerPage]);
  

  const dealerColumns = [
    { name: 'Business Name', selector: row => row.businessName, sortable: true },
    { name: 'Phone Number', selector: row => row?.phoneNumber, sortable: true },
    {
      name: 'Last Login',
      selector: row => moment(row.lastLogin).format("DD/MM/YYYY hh:mm A"),
      sortable: true,
    },
  ];

  const customerColumns = [
    { name: 'Name', selector: row => row.name, sortable: true },
    { name: 'Phone Number', selector: row => row?.phoneNumber, sortable: true },
    {
      name: 'Last Login',
      selector: row => moment(row.lastLogin).format("DD/MM/YYYY hh:mm A"),
      sortable: true,
    },
  ];

  const handleDealerPageChange = (page) => setDealerPage(page);
  const handleDealerRowsPerPageChange = (newPerPage, page) => {
    setDealerRowsPerPage(newPerPage);
    setDealerPage(page);
  };
  
  const handleCustomerPageChange = (page) => setCustomerPage(page);
  const handleCustomerRowsPerPageChange = (newPerPage, page) => {
    setCustomerRowsPerPage(newPerPage);
    setCustomerPage(page);
  };
  
  

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ mt: 10, textAlign: "center" }}>
        <CustomLoader />
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Admin Dashboard</title>
      </Helmet>

      <Typography variant="h4" sx={{ mb: 5 }}>
        Hi, Welcome
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4} onClick={() => navigate('/dealer-management')} style={{cursor: "pointer"}}>
          <AppWidgetSummary title="Total Dealers" total={data?.totalDealers} color="warning" icon={"circum:user"} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} onClick={() => navigate('/customer-management')} style={{cursor: "pointer"}}>
          <AppWidgetSummary title="Total Customers" total={data?.totalCustomers} color="error" icon={"circum:user"} />
        </Grid>
        <Grid item xs={12} sm={6} md={4} onClick={() => navigate('/reports-and-analytics-management', { state: { dashboard : true }})} style={{cursor: "pointer"}}>
          <AppWidgetSummary title="Total Revenue" total={data?.totalRevenue} color="info" icon={"mdi:currency-usd"} />
        </Grid>
      </Grid>

      {/* Recent Logins Tables */}
      <Grid container spacing={3} sx={{ mt: 4 }}>
      <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Recent Dealer Activity
          </Typography>

          <div style={{ display: "flex", flexDirection: "column", height: 450 }}>
            <div style={{ flex: 1, overflowY: "auto" }}>
              {dealerData.length > 0 ? (
                <DataTable
                  columns={dealerColumns}
                  data={dealerData}
                  pagination={false}
                  highlightOnHover
                  striped
                  customStyles={stickyHeaderStyles}
                />
              ) : (
                <Typography sx={{ textAlign: 'center', mt: 2, color: 'text.secondary', background: '#f0f0f0', padding: '12px', borderRadius: '8px' }}>
                  No records to display
                </Typography>
              )}
            </div>
            {dealerData.length > 0 && (
              <div style={{ position: "sticky", bottom: 0, backgroundColor: "#fff", padding: "8px 0" }}>
                <TablePagination
                  component="div"
                  count={dealerTotalRows}
                  page={dealerPage - 1}
                  onPageChange={(e, newPage) => handleDealerPageChange(newPage + 1)}
                  rowsPerPage={dealerRowsPerPage}
                  onRowsPerPageChange={(e) =>
                    handleDealerRowsPerPageChange(parseInt(e.target.value, 10), dealerPage)
                  }
                  rowsPerPageOptions={[10, 20, 50]}
                />
              </div>
            )}
          </div>
        </Grid>



        <Grid item xs={12} md={6}>
          <Typography variant="h6" gutterBottom>
            Recent Customer Activity
          </Typography>

          <div style={{ display: "flex", flexDirection: "column", height: 450 }}>
            <div style={{ flex: 1, overflowY: "auto" }}>
              {customerData.length > 0 ? (
                <DataTable
                  columns={customerColumns}
                  data={customerData}
                  pagination={false}
                  highlightOnHover
                  striped
                  customStyles={stickyHeaderStyles}
                />
              ) : (
                <Typography sx={{ textAlign: 'center', mt: 2, color: 'text.secondary', background: '#f0f0f0', padding: '12px', borderRadius: '8px' }}>
                  No records to display
                </Typography>
              )}
            </div>
            {customerData.length > 0 && (
              <div style={{ position: "sticky", bottom: 0, backgroundColor: "#fff", padding: "8px 0" }}>
                <TablePagination
                  component="div"
                  count={customerTotalRows}
                  page={customerPage - 1}
                  onPageChange={(e, newPage) => handleCustomerPageChange(newPage + 1)}
                  rowsPerPage={customerRowsPerPage}
                  onRowsPerPageChange={(e) =>
                    handleCustomerRowsPerPageChange(parseInt(e.target.value, 10), customerPage)
                  }
                  rowsPerPageOptions={[10, 20, 50]}
                />
              </div>
            )}
          </div>
        </Grid>

      </Grid>
    </Container>
  );
};

export default DashboardAppPage;
